import apollo from '@/scripts/cursor';

const cursor = new Map();

cursor.set('scale-center-in', (target) => {
  apollo.ref.getProperty('r').value = 50;
  apollo.ref.trackMouse = false;
  const rect = target.element.getBoundingClientRect();
  apollo.ref.coords = {
    x: rect.left + rect.width / 2,
    y: rect.top + rect.height / 2,
  };
});
cursor.set('scale-center-out', () => {
  apollo.ref.getProperty('r').value = 30;
  apollo.ref.trackMouse = true;
});

cursor.set('discover-in', (target) => {
  apollo.ref.getProperty('r').value = 10;
  apollo.ref.trackMouse = false;
  const rect = target.element.getBoundingClientRect();
  apollo.ref.coords = {
    x: rect.right - 5,
    y: rect.bottom - 5,
  };
});
cursor.set('discover-out', () => {
  apollo.ref.getProperty('r').value = 30;
  apollo.ref.trackMouse = true;
});

cursor.set('read-more-in', (target) => {
  console.log('so')
  apollo.ref.getProperty('r').value = 10;
  apollo.ref.trackMouse = false;
  const rect = target.element.getBoundingClientRect();
  apollo.ref.coords = {
    x: rect.right,
    y: rect.bottom - 18,
  };
});
cursor.set('read-more-out', () => {
  apollo.ref.getProperty('r').value = 30;
  apollo.ref.trackMouse = true;
});

cursor.set('opacity-in', () => {
  apollo.ref.getProperty('opacity').value = 0;
});
cursor.set('opacity-out', () => {
  apollo.ref.getProperty('opacity').value = 1;
});

cursor.set('scale-in', () => {
  apollo.ref.getProperty('r').value = 50;
});
cursor.set('scale-out', () => {
  apollo.ref.getProperty('r').value = 30;
});

export default cursor;
